import * as _ from 'lodash';

const translateRuneStats = {
	A:"Armor",
	AD:"Attack Damage",
	AP:"Ability Power",
	AD_PL:"Attack Damage/Level",
	AP_PL:"Ability Power/Level",
	A_PL:"Armor/Level",
	H:"Health",
	H_PL:"Health/Level",
	MP:"Magic Penetration",
	MR:"Magic Resist",
	MR_PL:"Magic Resist/Level"
};

//TODO lethality runes are completely missing anything in the stats section.
//TODO not sure where
//TODO percent attack speed, FlatCritDamageMod, PercentMovementSpeedMod, rPercentTimeDeadMod, rFlatGoldPer10Mod, PercentEXPBonus, FlatEnergyRegenMod, rFlatEnergyRegenModPerLevel,
//TODO FlatEnergyPoolMod, rFlatEnergyModPerLevel, PercentHPPoolMod, PercentSpellVampMod

const RiotStatsMap = {
	FlatHPPoolMod:"H",
	rFlatHPModPerLevel:"H_PL",
	FlatMPPoolMod:"MA",
	rFlatMPModPerLevel:"MA_PL",
	FlatHPRegenMod:"HR",
	rFlatHPRegenModPerLevel:"HR_PL",
	FlatMPRegenMod:"MAR",
	rFlatMPRegenModPerLevel:"MAR_PL",
	FlatArmorMod:"A",
	rFlatArmorModPerLevel:"A_PL",
	FlatPhysicalDamageMod:"AD",
	rFlatPhysicalDamageModPerLevel:"AD_PL",
	FlatCritChanceMod:"C",
	FlatSpellBlockMod:"MR",
	rFlatSpellBlockModPerLevel:"MR_PL",
	rPercentCooldownMod:"CD",
	rPercentCooldownModPerLevel:"CD_PL",
	FlatMagicDamageMod:"AP",
	rFlatMagicDamageModPerLevel:"AP_PL",
	rFlatMagicPenetrationMod:"MP",
	PercentLifeStealMod:"PLS"

};

export abstract class SimStats{
	//Attack damage
	AD?:number;
	AD_PL?:number;
	AD_B?:number;

	//Ability power
	AP?:number;
	AP_PL?:number;
	AP_B?:number;

	//armor
	A?:number;
	A_PL?:number;
	A_B?:number;

	//Magic Resist
	MR?:number;
	MR_PL?:number;
	MR_B?:number;

	//Magic Pen
	MP?:number;
	MP_PL?:number;
	MP_B?:number;

	//MAX Health
	H?:number;
	H_PL?:number;
	H_B?:number;

	//MAX Mana
	MA?:number;
	MA_PL?:number;
	MA_B?:number;

	//Mana Regen
	MAR?:number;
	MAR_PL?:number;
	MAR_B?:number;

	//Cooldown
	CD?:number;
	CD_PL?:number;
	CD_B?:number;

	//Lethality
	L?:number;
	L_PL?:number;
	L_B?:number;

	//HP Regen
	HR?:number;
	HR_PL?:number;
	HR_B?:number;

	//Crit
	C?:number;
	C_PL?:number;
	C_B?:number;

	//Movement Speed
	MS?:number;
	MS_PL?:number;
	MS_B?:number;


	//Percent Lifesteal
	PLS?:number;
	PLS_PL?:number;
	PLS_B?:number;


	//TODO deal with attack speed
	//AttackSpeed
	// AS?:number;
	// AS_PL?:number;
	// AS_B?:number;



	static BSTATS:string[] = ["AD","AP","A","MR","MP","H","MA","MAR","CD","L","HR","C"];

	static getNameForStat(statName:string):string{
		return translateRuneStats[statName];
	}

	static copyToObject(simStats:SimStats, object:any){
		_.forOwn(simStats, (value, key)=>{object[key] = value})
	}

	static setStats(toSet:SimStats, setWith:SimStats){
		_.forOwn(setWith,(statValue, statName)=>{
			toSet[statName] = setWith[statName]
		});
	}

	static setSimStatsFromRiotData(simStats:SimStats, riotData:any){
		_.forOwn(RiotStatsMap,(simStatName, riotStatName)=>{
			if (typeof riotData[riotStatName] == "number"){
				simStats[simStatName] = riotData[riotStatName];
			}
		});
	}

	static constructSimStats():SimStats{
		return {};
	}

	static addSimStats(addTo:SimStats, addFrom:SimStats){
		_.forOwn(addFrom,(value, statName)=>{
			if (typeof addTo[statName] != 'number'){
				addTo[statName] = 0;
			}
			addTo[statName] += addFrom[statName];
		})
	}

	static addRiotDataToSimStats(addTo:SimStats, riotData:any){
		let addFrom = SimStats.constructSimStats();
		SimStats.setSimStatsFromRiotData(addFrom, riotData);
		SimStats.addSimStats(addTo, addFrom);
	}
}

export class SimStatsInstance extends SimStats{

}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/fbobjects/calculation/SimStats.ts